import * as React from 'react';
import { Checkbox as MatCheckbox, FormControlLabel, SxProps, Theme } from '@mui/material';

export interface CheckboxProps {
  disabled?: boolean;
  disableRipple?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  checked?: boolean;
  dataProp?: string;
  descriptionLabel?: string;
  id: string;
  sx?: SxProps<Theme>;
}

const Checkbox: React.FunctionComponent<CheckboxProps> = ({ onChange, checked, disabled, dataProp, descriptionLabel, id, sx }: CheckboxProps) => {
  return (
    <FormControlLabel
      control={
        <MatCheckbox
          inputProps={{ 'aria-label': descriptionLabel }}
          checked={checked}
          size="small"
          name={id}
          id={id}
          data-selector={dataProp}
          disabled={disabled}
          // disableRipple
          onChange={onChange}
          sx={sx}
        />
      }
      label={id}
    />
  );
};

Checkbox.displayName = 'Checkbox';

export { Checkbox };
